import ApplicationSerializer from 'eflex/serializers/application';

export default class WieConfigLinesSerializer extends ApplicationSerializer {
  attrs = {
    stroke: {
      embedded: 'always',
    },
    arrows: {
      embedded: 'always',
    },
  };
}
